import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cms from '@moka-fe/cms';
import classNames from 'classnames';
import moment from 'moment';
import { Button, Empty, Loading, Select, Table } from 'sugar-design';
import * as sdf from '@SDFoundation';

import Dialog from '@/components/common/Dialog';

import { DATE_TIME_FORMAT } from '@/constants/common';
import {
  clearExcelDupApplications,
  getDupApplicationsByImportId,
} from '@/redux/actions/applications';
import { downloadByUrl, formatLocationListToShortStr } from '@/utils/common';
import { getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';

const i18n = getI18n();
class ExcelApplicationList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredJobId: null,
    };
  }

  jobFilterChanged = (filteredJobId) =>
    this.setState({
      filteredJobId,
    });

  onShowDupApplications = (importId) => {
    const {
      params: { orgId },
    } = this.props.match;
    return () => {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ loadingDupApplications: true, showDialog: true });
      this.props.getDupApplicationsByImportId(orgId, importId, (error) => {
        // eslint-disable-next-line react/no-unused-state
        this.setState({ loadingDupApplications: false, showDialog: !error });
      });
    };
  };

  onHideDupApplications = () => {
    this.setState({ showDialog: false }, () => {
      this.props.clearExcelDupApplications();
    });
  };

  renderTable(rowData) {
    const tableHeaders = [
      { dataIndex: 'jobTitle', title: i18n.t`职位名称`, key: 'jobTitle', width: 180 },
      {
        dataIndex: 'createdAt',
        title: i18n.t`上传时间`,
        key: 'createdAt',
        width: 160,
        render: (row) => (
          <div className={styles.customRow}>{moment(row.createdAt).format(DATE_TIME_FORMAT)}</div>
        ),
      },
      {
        title: i18n.t`上传数量`,
        dataIndex: 'totalCount',
        key: 'totalCount',
        width: 100,
      },
      {
        dataIndex: 'dupCount',
        title: i18n.t`重复候选人`,
        key: 'dupCount',
        width: 100,
        render: (row) => {
          const showCount = new Date(row.createdAt).getTime() > 1519747200000;
          return (
            <div
              className={classNames(showCount ? styles.link : '', styles.customRow)}
              onClick={
                row.dupCount > 0 ? this.onShowDupApplications(row.headhunterExcelImportId) : null
              }
            >
              {showCount ? row.dupCount : '-'}
            </div>
          );
        },
      },
      { dataIndex: 'stage3Count', title: i18n.t`通过筛选`, key: 'stage3Count', width: 100 },
      {
        dataIndex: 'interviewCreatedCount',
        title: i18n.t`安排面试`,
        key: 'interviewCreatedCount',
        width: 100,
      },
      { dataIndex: 'hiredCount', title: i18n.t`录用`, key: 'hiredCount', width: 100 },
      {
        id: 'excelUrl',
        width: 140,
        render: (row) => (
          <Button
            size="md"
            type="tertiaryLight"
            onClick={() => downloadByUrl(row.excelUrl)}
          >{i18n.t`下载上传文件`}</Button>
        ),
      },
    ];
    return (
      <Table.BasicTable
        width="1136px"
        tableClassName={styles.excelApplicationsList}
        headers={tableHeaders}
        rows={rowData}
        columnResizeEnabled
      />
    );
  }

  render() {
    const { filteredJobId, showDialog } = this.state;
    const { relatedJobEntities, excelApplicationStats, excelDupApplications } = this.props;
    // 构建职位下拉列表选项
    const jobFilterOptions = Object.values(relatedJobEntities).map((job) => {
      return {
        value: job.id,
        label: job.title,
        extra: formatLocationListToShortStr(job.locations, '·') + '·' + job.commitment,
        innerClassName: 'Select-option-job',
      };
    });

    let filteredExcelImports = excelApplicationStats || [];
    if (filteredJobId) {
      filteredExcelImports = filteredExcelImports.filter(
        (application) => application.jobId === filteredJobId
      );
    }
    return (
      <div className={classNames('orgdetail__content', cms.mgt24)}>
        <div className="list__filters">
          <div className={styles.filterBlock}>
            <label
              className={classNames(styles.filterLabel, sdf.boldBodySecondary)}
            >{i18n.t`推荐职位`}</label>
            <Select
              clearable
              searchable
              size="md"
              className="list__filter"
              placeholder={i18n.t`请选择职位`}
              value={filteredJobId}
              options={jobFilterOptions}
              onChange={this.jobFilterChanged}
            />
          </div>
        </div>
        {excelApplicationStats.length === 0 ? (
          <div className="list-empty">
            <Empty title={i18n.t`无批量推荐历史`} />
          </div>
        ) : (
          this.renderTable(filteredExcelImports)
        )}
        <Dialog
          title={i18n.t`重复添加候选人`}
          isOpen={showDialog}
          needCancelButton={false}
          submitText={i18n.t`我知道了`}
          onSubmit={this.onHideDupApplications}
          onCancel={this.onHideDupApplications}
        >
          {!excelDupApplications || excelDupApplications.length <= 0 ? (
            <Loading message={i18n.t`加载中…`} />
          ) : (
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>{i18n.t`姓名`}</th>
                  <th>{i18n.t`电话`}</th>
                  <th>{i18n.t`邮箱`}</th>
                  <th>{i18n.t`年龄`}</th>
                  <th>{i18n.t`性别`}</th>
                  <th>{i18n.t`学历`}</th>
                  <th>{i18n.t`推荐有效性`}</th>
                </tr>
              </thead>
              <tbody>
                {excelDupApplications.map((app) => {
                  return (
                    <tr key={app.id}>
                      <td>{app.name}</td>
                      <td>{app.phone}</td>
                      <td>{app.email}</td>
                      <td>{app.age}</td>
                      <td>{app.gender}</td>
                      <td>{app.academicDegree}</td>
                      <td>{app.merged ? i18n.t`无效推荐` : i18n.t`有效推荐`}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Dialog>
      </div>
    );
  }
}

ExcelApplicationList.propTypes = {
  excelApplicationStats: PropTypes.array.isRequired,
};

ExcelApplicationList.defaultProps = {
  applicationFilterOptions: [],
  excelApplicationStats: [],
  relatedJobEntities: {},
};

function mapStateToProps(state) {
  return {
    excelApplicationStats: state.applications.excelApplicationStats,
    relatedJobEntities: state.jobs.relatedJobEntities,
    excelDupApplications: state.applications.excelDupApplications,
  };
}

export default connect(mapStateToProps, {
  getDupApplicationsByImportId,
  clearExcelDupApplications,
})(ExcelApplicationList);
